import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../../package.json";
import { Radio } from "antd";
import Swal from "sweetalert2";
import { admission } from "../ADMISSION";

export default class Insertpresent2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ID_LOGIN: null,
      REGISTER_ID: null,
      REGISTER_TYPE_ID: null,
      LEVEL_EDU_ID: null,
      PLAN_NAME: null,
      LEVEL_MEMBER_YEAR: null,
      LEVEL_DATE: null,
      ID_LOGIN2: null,
      REGISTER_ID2: null,
      REGISTER_TYPE_ID2: null,
      LEVEL_EDU_ID2: null,
      PLAN_NAME2: null,
      LEVEL_MEMBER_YEAR2: null,
      LEVEL_DATE2: null,
      LEVEL_EDU_IDTor: null,
      PLAN_NAMETor: null,
      LEVEL_MEMBER_YEARTor: null,
      LEVEL_DATETor: null,
      // LEVEL_MEMBER_DATE: null,
      ddate: null,
      mdate: null,
      ydate: null,
      ddate2: null,
      mdate2: null,
      ydate2: null,
      ddateTor: null,
      mdateTor: null,
      ydateTor: null,
      LEVEL_MEMBER_SCHOOL: null,
      LEVEL_MEMBER_SCHOOL2: null,
      LEVEL_MEMBER_PROVINCY: null,
      LEVEL_MEMBER_PROVINCY2: null,
      LEVEL_MEMBER_VGA: null,
      LEVEL_MEMBER_VGA2: null,
      LEVEL_MEMBER_SCHOOLTOR: null,
      LEVEL_MEMBER_PROVINCYTOR: null,
      LEVEL_MEMBER_VGATOR: null,
      LEVEL_ID: null,
      LEVEL_IDTor: null,

      tumbol: null,
      tumbol2: null,
      tumbolTor: null,
      amphur: null,
      amphur2: null,
      amphurTor: null,
      zipcode: null,
      zipcode2: null,
      zipcodeTor: null,
      status: null,
      ask: 2,
      selectyear: [],
      array_province: [],
      array_school: [],
      array_level: [],
      array_plan: [],
      selectyear2: [],
      array_province2: [],
      array_school2: [],
      array_level2: [],
      array_plan2: [],
      selectyearTor: [],
      array_provinceTor: [],
      array_schoolTor: [],
      array_levelTor: [],
      array_planTor: [],
    };
    this.selectday = [
      { value: "01", label: "1" },
      { value: "02", label: "2" },
      { value: "03", label: "3" },
      { value: "04", label: "4" },
      { value: "05", label: "5" },
      { value: "06", label: "6" },
      { value: "07", label: "7" },
      { value: "08", label: "8" },
      { value: "09", label: "9" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
      { value: "13", label: "13" },
      { value: "14", label: "14" },
      { value: "15", label: "15" },
      { value: "16", label: "16" },
      { value: "17", label: "17" },
      { value: "18", label: "18" },
      { value: "19", label: "19" },
      { value: "20", label: "20" },
      { value: "21", label: "21" },
      { value: "22", label: "22" },
      { value: "23", label: "23" },
      { value: "24", label: "24" },
      { value: "25", label: "25" },
      { value: "26", label: "26" },
      { value: "27", label: "27" },
      { value: "28", label: "28" },
      { value: "29", label: "29" },
      { value: "30", label: "30" },
      { value: "31", label: "31" },
    ];
    this.selectmonth = [
      { value: "01", label: "ม.ค." },
      { value: "02", label: "ก.พ." },
      { value: "03", label: "มี.ค." },
      { value: "04", label: "เม.ย." },
      { value: "05", label: "พ.ค." },
      { value: "06", label: "มิ.ย." },
      { value: "07", label: "ก.ค." },
      { value: "08", label: "ส.ค." },
      { value: "09", label: "ก.ย." },
      { value: "10", label: "ต.ค." },
      { value: "11", label: "พ.ย." },
      { value: "12", label: "ธ.ค." },
    ];
    this.handleProvinceChange = this.handleProvinceChange.bind(this);
    this.handleProvinceChange2 = this.handleProvinceChange2.bind(this);
    this.handleProvinceChangeTor = this.handleProvinceChangeTor.bind(this);
    this.handleSchoolChange = this.handleSchoolChange.bind(this);
    this.handleSchoolChange2 = this.handleSchoolChange2.bind(this);
    this.handleSchoolChangeTor = this.handleSchoolChangeTor.bind(this);
    this.handlelevelChange = this.handlelevelChange.bind(this);
    this.handlelevelChange2 = this.handlelevelChange2.bind(this);
    this.handlelevelChangeTor = this.handlelevelChangeTor.bind(this);
    this.handleLevelDateChange = this.handleLevelDateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.Vut = this.Vut.bind(this);
  }
  Vut(event) {
    this.setState({ ask: event.target.value });
  }
  componentDidMount() {
    // axios.get("https://git.kpru.ac.th/admission2017/student/loadpresent/"+localStorage.getItem("ID_LOGIN")).then((respone) => {
    axios
      .get(admission + "/student/loadpresent/" + localStorage.getItem("ID_LOGIN"))
      .then((respone) => {
        const data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        console.log(data);
        let data_school = data[0].DATA_SCHOOL;
        this.setState({ REGISTER_ID: data[0]["REGISTER_ID"] });
        // this.setState({ LEVEL_EDU_ID: data[0]["LEVEL_EDU_ID"] });
        this.setState({ status: data[0]["REGISTER_STATUS"] });
        this.setState({
          REGISTER_TYPE_ID: data[0]["REGISTER_TYPE_ID"],
        });
        if (data[0].REGISTER_TYPE_ID === "7" || data[0].REGISTER_TYPE_ID === "4") {
          data_school = data_school.filter(({ LEVEL_EDU_ID }) => LEVEL_EDU_ID !== "3");
          if (data[0].REGISTER_TYPE_ID === "7") {
            //โชววุฒิตรี โท
            this.setState({ LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY });
            this.setState({ LEVEL_MEMBER_SCHOOL: data_school[0].LEVEL_MEMBER_SCHOOL });
            this.setState({ LEVEL_EDU_ID: data_school[0].LEVEL_EDU_ID });
            this.setState({ PLAN_NAME: data_school[0].PLAN_NAME });
            this.setState({ LEVEL_MEMBER_VGA: data_school[0].LEVEL_MEMBER_VGA });
            this.setState({ LEVEL_ID: data_school[0].LEVEL_ID });
            let data_kru = data_school.filter(({ LEVEL_EDU_ID }) => LEVEL_EDU_ID === "13");
            data_school = data_school.filter(({ LEVEL_EDU_ID }) => LEVEL_EDU_ID !== "13");
            // data_school = data_school.reverse();
            console.log(data_school);
            let headers = new Headers({
              "Content-Type": "application/x-www-form-urlencoded",
            });
            /////////////////////////////////////////
            axios
              .post(
                "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
                { LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY },
                { headers: headers }
              )
              .then((school) => {
                this.setState({ array_school: school.data });
              });
            ////////////////////////////////////
            axios
              .get(admission + "/dashboard_degree/showlevelplan/" + data_school[0].LEVEL_EDU_ID)
              .then((plan) => {
                this.setState({ array_plan: plan.data });
              });
            ////////////////////////////////////
            if (
              data_school[0].LEVEL_MEMBER_DATE !== "" &&
              data_school[0].LEVEL_MEMBER_DATE !== undefined &&
              data_school[0].LEVEL_MEMBER_DATE !== null
            ) {
              const leveldate1 = data_school[0].LEVEL_MEMBER_DATE.split("/");
              console.log(leveldate1[2]);
              this.setState({ ddate: leveldate1[0] });
              this.setState({ mdate: leveldate1[1] });
              this.setState({ ydate: leveldate1[2] });
            } else {
              console.log("sjkhdkjs");
            }
            if (
              data_school[0].LEVEL_MEMBER_YEAR !== "" &&
              data_school[0].LEVEL_MEMBER_YEAR !== undefined &&
              data_school[0].LEVEL_MEMBER_YEAR !== null
            ) {
              this.setState({ LEVEL_MEMBER_YEAR: data_school[0].LEVEL_MEMBER_YEAR });
            }
            //////////////////////////// วุฒิตรี
            this.setState({ LEVEL_MEMBER_PROVINCYTOR: data_school[1].LEVEL_MEMBER_PROVINCY });
            this.setState({ LEVEL_MEMBER_SCHOOLTOR: data_school[1].LEVEL_MEMBER_SCHOOL });
            this.setState({ LEVEL_EDU_IDTor: data_school[1].LEVEL_EDU_ID });
            this.setState({ PLAN_NAMETor: data_school[1].PLAN_NAME });
            this.setState({ LEVEL_MEMBER_VGATOR: data_school[1].LEVEL_MEMBER_VGA });
            this.setState({ LEVEL_IDTor: data_school[1].LEVEL_ID });
            console.log(data_school);
            /////////////////////////////////////////
            axios
              .post(
                "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
                { LEVEL_MEMBER_PROVINCY: data_school[1].LEVEL_MEMBER_PROVINCY },
                { headers: headers }
              )
              .then((school) => {
                this.setState({ array_schoolTor: school.data });
              });
            ////////////////////////////////////
            axios
              .get(admission + "/dashboard_degree/showlevelplan/" + data_school[1].LEVEL_EDU_ID)
              .then((plan) => {
                this.setState({ array_planTor: plan.data });
              });
            ////////////////////////////////////
            if (
              data_school[1].LEVEL_MEMBER_DATE !== "" &&
              data_school[1].LEVEL_MEMBER_DATE !== undefined &&
              data_school[1].LEVEL_MEMBER_DATE !== null
            ) {
              const leveldateTor = data_school[1].LEVEL_MEMBER_DATE.split("/");
              this.setState({ ddateTor: leveldateTor[0] });
              this.setState({ mdateTor: leveldateTor[1] });
              this.setState({ ydateTor: leveldateTor[2] });
            } else {
            }
            if (
              data_school[1].LEVEL_MEMBER_YEAR !== "" &&
              data_school[1].LEVEL_MEMBER_YEAR !== undefined &&
              data_school[1].LEVEL_MEMBER_YEAR !== null
            ) {
              this.setState({ LEVEL_MEMBER_YEARTor: data_school[1].LEVEL_MEMBER_YEAR });
            }
            if (data_kru.length > 0) {
              this.setState({ ask: 1 });
              this.setState({ LEVEL_MEMBER_PROVINCY2: data_kru[0].LEVEL_MEMBER_PROVINCY });
              this.setState({ LEVEL_MEMBER_SCHOOL2: data_kru[0].LEVEL_MEMBER_SCHOOL });
              this.setState({ LEVEL_EDU_ID2: data_kru[0].LEVEL_EDU_ID });
              this.setState({ PLAN_NAME2: data_kru[0].PLAN_NAME });
              this.setState({ LEVEL_MEMBER_VGA2: data_kru[0].LEVEL_MEMBER_VGA });
              this.setState({ LEVEL_ID2: data_kru[0].LEVEL_ID });
              this.setState({ LEVEL_MEMBER_YEAR2: data_kru[0].LEVEL_MEMBER_YEAR });
              if (
                data_kru[0].LEVEL_MEMBER_DATE !== "" &&
                data_kru[0].LEVEL_MEMBER_DATE !== undefined &&
                data_kru[0].LEVEL_MEMBER_DATE !== null
              ) {
                const leveldate1 = data_kru[0].LEVEL_MEMBER_DATE.split("/");
                console.log(leveldate1[2]);
                this.setState({ ddate2: leveldate1[0] });
                this.setState({ mdate2: leveldate1[1] });
                this.setState({ ydate2: leveldate1[2] });
              } else {
                console.log("sjkhdkjs");
              }
              axios
                .post(
                  "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
                  { LEVEL_MEMBER_PROVINCY: data_kru[0].LEVEL_MEMBER_PROVINCY },
                  { headers: headers }
                )
                .then((school) => {
                  this.setState({ array_school2: school.data });
                });
              ////////////////////////////////////
              axios
                .get(admission + "/dashboard_degree/showlevelplan/" + data_kru[0].LEVEL_EDU_ID)
                .then((plan) => {
                  this.setState({ array_plan2: plan.data });
                });
            }
          } else if (data[0].REGISTER_TYPE_ID === "4") {
            //โชววุฒิตรี

            let data_kru = data_school.filter(({ LEVEL_EDU_ID }) => LEVEL_EDU_ID === "13");
            data_school = data_school.filter(({ LEVEL_EDU_ID }) => LEVEL_EDU_ID !== "13");
            data_school = data_school.reverse();
            this.setState({ LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY });
            this.setState({ LEVEL_MEMBER_SCHOOL: data_school[0].LEVEL_MEMBER_SCHOOL });
            this.setState({ LEVEL_EDU_ID: data_school[0].LEVEL_EDU_ID });
            this.setState({ PLAN_NAME: data_school[0].PLAN_NAME });
            this.setState({ LEVEL_MEMBER_VGA: data_school[0].LEVEL_MEMBER_VGA });
            this.setState({ LEVEL_ID: data_school[0].LEVEL_ID });

            console.log(data_school);
            let headers = new Headers({
              "Content-Type": "application/x-www-form-urlencoded",
            });
            /////////////////////////////////////////
            axios
              .post(
                "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
                { LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY },
                { headers: headers }
              )
              .then((school) => {
                this.setState({ array_school: school.data });
              });
            ////////////////////////////////////
            axios
              .get(
                "https://admission.kpru.ac.th/admission2017/dashboard_degree/showlevelplan/" +
                  data_school[0].LEVEL_EDU_ID
              )
              .then((plan) => {
                this.setState({ array_plan: plan.data });
              });
            ////////////////////////////////////
            if (
              data_school[0].LEVEL_MEMBER_DATE !== "" &&
              data_school[0].LEVEL_MEMBER_DATE !== undefined &&
              data_school[0].LEVEL_MEMBER_DATE !== null
            ) {
              const leveldate1 = data_school[0].LEVEL_MEMBER_DATE.split("/");
              console.log(leveldate1[2]);
              this.setState({ ddate: leveldate1[0] });
              this.setState({ mdate: leveldate1[1] });
              this.setState({ ydate: leveldate1[2] });
            } else {
              console.log("sjkhdkjs");
            }
            if (
              data_school[0].LEVEL_MEMBER_YEAR !== "" &&
              data_school[0].LEVEL_MEMBER_YEAR !== undefined &&
              data_school[0].LEVEL_MEMBER_YEAR !== null
            ) {
              this.setState({ LEVEL_MEMBER_YEAR: data_school[0].LEVEL_MEMBER_YEAR });
            }
            if (data_kru.length > 0) {
              this.setState({ ask: 1 });
              this.setState({ LEVEL_MEMBER_PROVINCY2: data_kru[0].LEVEL_MEMBER_PROVINCY });
              this.setState({ LEVEL_MEMBER_SCHOOL2: data_kru[0].LEVEL_MEMBER_SCHOOL });
              this.setState({ LEVEL_EDU_ID2: data_kru[0].LEVEL_EDU_ID });
              this.setState({ PLAN_NAME2: data_kru[0].PLAN_NAME });
              this.setState({ LEVEL_MEMBER_VGA2: data_kru[0].LEVEL_MEMBER_VGA });
              this.setState({ LEVEL_ID2: data_kru[0].LEVEL_ID });
              this.setState({ LEVEL_MEMBER_YEAR2: data_kru[0].LEVEL_MEMBER_YEAR });
              if (
                data_kru[0].LEVEL_MEMBER_DATE !== "" &&
                data_kru[0].LEVEL_MEMBER_DATE !== undefined &&
                data_kru[0].LEVEL_MEMBER_DATE !== null
              ) {
                const leveldate1 = data_kru[0].LEVEL_MEMBER_DATE.split("/");
                console.log(leveldate1[2]);
                this.setState({ ddate2: leveldate1[0] });
                this.setState({ mdate2: leveldate1[1] });
                this.setState({ ydate2: leveldate1[2] });
              } else {
                console.log("sjkhdkjs");
              }
              axios
                .post(
                  "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
                  { LEVEL_MEMBER_PROVINCY: data_kru[0].LEVEL_MEMBER_PROVINCY },
                  { headers: headers }
                )
                .then((school) => {
                  this.setState({ array_school2: school.data });
                });
              ////////////////////////////////////
              axios
                .get(admission + "/dashboard_degree/showlevelplan/" + data_kru[0].LEVEL_EDU_ID)
                .then((plan) => {
                  this.setState({ array_plan2: plan.data });
                });
            }
          }
        } else {
          //โชววุฒิม.6
          this.setState({ LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY });
          this.setState({ LEVEL_MEMBER_SCHOOL: data_school[0].LEVEL_MEMBER_SCHOOL });
          this.setState({ LEVEL_EDU_ID: data_school[0].LEVEL_EDU_ID });
          this.setState({ PLAN_NAME: data_school[0].PLAN_NAME });
          this.setState({ LEVEL_MEMBER_VGA: data_school[0].LEVEL_MEMBER_VGA });
          this.setState({ LEVEL_ID: data_school[0].LEVEL_ID });

          console.log(data_school);
          let headers = new Headers({
            "Content-Type": "application/x-www-form-urlencoded",
          });
          /////////////////////////////////////////
          axios
            .post(
              "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
              { LEVEL_MEMBER_PROVINCY: data_school[0].LEVEL_MEMBER_PROVINCY },
              { headers: headers }
            )
            .then((school) => {
              this.setState({ array_school: school.data });
            });
          ////////////////////////////////////
          axios
            .get(admission + "/dashboard_degree/showlevelplan/" + data_school[0].LEVEL_EDU_ID)
            .then((plan) => {
              this.setState({ array_plan: plan.data });
            });
          ////////////////////////////////////
          if (
            data_school[0].LEVEL_MEMBER_DATE !== "" &&
            data_school[0].LEVEL_MEMBER_DATE !== undefined &&
            data_school[0].LEVEL_MEMBER_DATE !== null
          ) {
            const leveldate1 = data_school[0].LEVEL_MEMBER_DATE.split("/");
            console.log(leveldate1[2]);
            this.setState({ ddate: leveldate1[0] });
            this.setState({ mdate: leveldate1[1] });
            this.setState({ ydate: leveldate1[2] });
          } else {
            console.log("sjkhdkjs");
          }
          if (
            data_school[0].LEVEL_MEMBER_YEAR !== "" &&
            data_school[0].LEVEL_MEMBER_YEAR !== undefined &&
            data_school[0].LEVEL_MEMBER_YEAR !== null
          ) {
            this.setState({ LEVEL_MEMBER_YEAR: data_school[0].LEVEL_MEMBER_YEAR });
          }
        }
      });

    axios.get(admission + "/dashboard_degree/showleveledu").then((level) => {
      this.setState({ array_level: level.data });
    });

    axios.get("https://mua.kpru.ac.th/frontend_tabian/graduate/ShowProvancy/").then((provancy) => {
      this.setState({ array_province: provancy.data.DetailListLoad });
      this.setState({ array_province2: provancy.data.DetailListLoad });
      this.setState({ array_provinceTor: provancy.data.DetailListLoad });
    });

    var newyear = new Date().getFullYear();
    var startyear = newyear;
    var stopyear = newyear - 70;
    var o = 0;
    var y = [];
    while (startyear > stopyear) {
      y[o] = startyear;
      o++;
      startyear--;
    }
    const ssss = y.map((d) => ({
      value: String(d + 543),
      label: d + 543,
      name: "ydate",
    }));
    this.setState({ selectyear: ssss });
  }

  handleProvinceChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: event.target.value },
        { headers: headers }
      )
      .then((school) => {
        this.setState({ array_school: school.data });
      });
  }
  handleProvinceChange2(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: event.target.value },
        { headers: headers }
      )
      .then((school) => {
        this.setState({ array_school2: school.data });
      });
  }
  handleProvinceChangeTor(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: event.target.value },
        { headers: headers }
      )
      .then((school) => {
        this.setState({ array_schoolTor: school.data });
      });
  }

  handleSchoolChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCY },
        { headers: headers }
      )
      .then((school) => {
        var i = 0;
        while (i < school.data.length) {
          if (school.data[i]["name_school"] === event.target.value) {
            this.setState({ tumbol: school.data[i]["tumbol"] });
            this.setState({ amphur: school.data[i]["amphur"] });
            this.setState({ zipcode: school.data[i]["zipcode"] });
          }
          i++;
        }
      });
  }
  handleSchoolChangeTor(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCYTOR },
        { headers: headers }
      )
      .then((school) => {
        var i = 0;
        while (i < school.data.length) {
          if (school.data[i]["name_school"] === event.target.value) {
            this.setState({ tumbolTor: school.data[i]["tumbol"] });
            this.setState({ amphurTor: school.data[i]["amphur"] });
            this.setState({ zipcodeTor: school.data[i]["zipcode"] });
          }
          i++;
        }
      });
  }
  handleSchoolChange2(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        "https://mua.kpru.ac.th/FrontEnd_Tabian/student/ShowDistricSchoolsStudent_present/",
        { LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCY2 },
        { headers: headers }
      )
      .then((school) => {
        var i = 0;
        while (i < school.data.length) {
          if (school.data[i]["name_school"] === event.target.value) {
            this.setState({ tumbol2: school.data[i]["tumbol"] });
            this.setState({ amphur2: school.data[i]["amphur"] });
            this.setState({ zipcode2: school.data[i]["zipcode"] });
          }
          i++;
        }
      });
  }

  handlelevelChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(admission + "/dashboard_degree/showlevelplan/" + event.target.value).then((plan) => {
      this.setState({ array_plan: plan.data });
    });
  }
  handlelevelChangeTor(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(admission + "/dashboard_degree/showlevelplan/" + event.target.value).then((plan) => {
      this.setState({ array_planTor: plan.data });
    });
  }
  handlelevelChange2(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(admission + "/dashboard_degree/showlevelplan/" + event.target.value).then((plan) => {
      this.setState({ array_plan2: plan.data });
    });
  }

  handleLevelDateChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    var leveldate = event.target.value.split("-");
    this.setState({
      LEVEL_MEMBER_DATE: leveldate[2] + "/" + leveldate[1] + "/" + leveldate[0],
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleChange2(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    let bodydata = {
      ID_LOGIN: localStorage.getItem("ID_LOGIN"),
      REGISTER_ID: this.state.REGISTER_ID,
      LEVEL_EDU_ID: this.state.LEVEL_EDU_ID,
      PLAN_NAME: this.state.PLAN_NAME,
      // LEVEL_MEMBER_YEAR: this.state.LEVEL_MEMBER_YEAR,
      LEVEL_MEMBER_YEAR: "-",
      LEVEL_MEMBER_DATE: this.state.ddate + "/" + this.state.mdate + "/" + this.state.ydate,
      LEVEL_MEMBER_SCHOOL: this.state.LEVEL_MEMBER_SCHOOL,
      LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCY,
      LEVEL_MEMBER_VGA: this.state.LEVEL_MEMBER_VGA,
      tumbol: this.state.tumbol,
      amphur: this.state.amphur,
      zipcode: this.state.zipcode,
    };
    console.log(bodydata);
    axios
      .post(admission + "/student_insertpresent2/updatepresent/" + this.state.REGISTER_ID, bodydata)
      .then((data) => {
        if (this.state.REGISTER_TYPE_ID === "4" || this.state.REGISTER_TYPE_ID === "7") {
          if (this.state.REGISTER_TYPE_ID === "7") {
            let bodydatas = {
              ID_LOGIN: localStorage.getItem("ID_LOGIN"),
              REGISTER_ID: this.state.REGISTER_ID,
              LEVEL_EDU_ID: this.state.LEVEL_EDU_IDTor,
              PLAN_NAME: this.state.PLAN_NAMETor,
              // LEVEL_MEMBER_YEAR: this.state.LEVEL_MEMBER_YEARTor,
              LEVEL_MEMBER_YEAR: "-",
              LEVEL_MEMBER_DATE:
                this.state.ddateTor + "/" + this.state.mdateTor + "/" + this.state.ydateTor,
              LEVEL_MEMBER_SCHOOL: this.state.LEVEL_MEMBER_SCHOOLTOR,
              LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCYTOR,
              LEVEL_MEMBER_VGA: this.state.LEVEL_MEMBER_VGATOR,
              tumbol: this.state.tumbolTor,
              amphur: this.state.amphurTor,
              zipcode: this.state.zipcodeTor,
            };
            console.log(bodydatas);
            axios
              .post(
                admission + "/student_insertpresent2/updatepresent/" + this.state.REGISTER_ID,
                bodydatas
              )
              .then((res) => {
                if (this.state.ask === 1) {
                  let bodydataask = {
                    ID_LOGIN: localStorage.getItem("ID_LOGIN"),
                    REGISTER_ID: this.state.REGISTER_ID,
                    LEVEL_EDU_ID: this.state.LEVEL_EDU_ID2,
                    PLAN_NAME: this.state.PLAN_NAME2,
                    // LEVEL_MEMBER_YEAR: this.state.LEVEL_MEMBER_YEAR2,
                    LEVEL_MEMBER_YEAR: "-",
                    LEVEL_MEMBER_DATE:
                      this.state.ddate2 + "/" + this.state.mdate2 + "/" + this.state.ydate2,
                    LEVEL_MEMBER_SCHOOL: this.state.LEVEL_MEMBER_SCHOOL2,
                    LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCY2,
                    LEVEL_MEMBER_VGA: this.state.LEVEL_MEMBER_VGA2,
                    tumbol: this.state.tumbol2,
                    amphur: this.state.amphur2,
                    zipcode: this.state.zipcode2,
                  };
                  axios
                    .post(
                      admission + "/student_insertpresent2/updatepresent/" + this.state.REGISTER_ID,
                      bodydataask
                    )
                    .then((res) => {
                      Swal.fire({
                        icon: "success",
                        title: "Success",
                        timer: 1500,
                        timerProgressBar: true,
                        showConfirmButton: false,
                      }).then((res) => {
                        window.location.href = "/" + packkagee.name + "/Insertpresent3";
                      });
                    });
                } else {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href = "/" + packkagee.name + "/Insertpresent3";
                  });
                }
              });
          } else if (this.state.REGISTER_TYPE_ID === "4") {
            if (this.state.ask === 1) {
              let bodydataask = {
                ID_LOGIN: localStorage.getItem("ID_LOGIN"),
                REGISTER_ID: this.state.REGISTER_ID,
                LEVEL_EDU_ID: this.state.LEVEL_EDU_ID2,
                PLAN_NAME: this.state.PLAN_NAME2,
                // LEVEL_MEMBER_YEAR: this.state.LEVEL_MEMBER_YEAR2,
                LEVEL_MEMBER_YEAR: "-",
                LEVEL_MEMBER_DATE:
                  this.state.ddate2 + "/" + this.state.mdate2 + "/" + this.state.ydate2,
                LEVEL_MEMBER_SCHOOL: this.state.LEVEL_MEMBER_SCHOOL2,
                LEVEL_MEMBER_PROVINCY: this.state.LEVEL_MEMBER_PROVINCY2,
                LEVEL_MEMBER_VGA: this.state.LEVEL_MEMBER_VGA2,
                tumbol: this.state.tumbol2,
                amphur: this.state.amphur2,
                zipcode: this.state.zipcode2,
              };
              axios
                .post(
                  admission + "/student_insertpresent2/updatepresent/" + this.state.REGISTER_ID,
                  bodydataask
                )
                .then((res) => {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href = "/" + packkagee.name + "/Insertpresent3";
                  });
                });
            } else {
              Swal.fire({
                icon: "success",
                title: "Success",
                timer: 1500,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then((res) => {
                window.location.href = "/" + packkagee.name + "/Insertpresent3";
              });
            }
          }
        } else {
          Swal.fire({
            icon: "success",
            title: "Success",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            window.location.href = "/" + packkagee.name + "/Insertpresent3";
          });
        }
      });
  }
  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลประวัติการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลประวัติการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลประวัติการศึกษา มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBCol lg="10" md="12" sm="12">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardTitle>ข้อมูลประวัติการศึกษา</MDBCardTitle>
                          <MDBCardText>
                            <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                            <br />
                            <span className="text-danger">
                              สถานศึกษาใดไม่ขึ้นชื่อภาษาอังกฤษ ให้ติดต่อ 055-706547
                            </span>
                            <MDBRow>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_MEMBER_PROVINCY">
                                    จังหวัดที่ตั้งสถานที่สำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="LEVEL_MEMBER_PROVINCY"
                                    name="LEVEL_MEMBER_PROVINCY"
                                    onChange={this.handleProvinceChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุจังหวัดที่ตั้งสถานที่สำเร็จการศึกษา
                                    </option>
                                    {this.state.array_province.map((data) => {
                                      return data.PROVINCE_NAME_TH ===
                                        this.state.LEVEL_MEMBER_PROVINCY ? (
                                        <>
                                          <option value={data.PROVINCE_NAME_TH} selected>
                                            {data.PROVINCE_NAME_TH}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.PROVINCE_NAME_TH}>
                                            {data.PROVINCE_NAME_TH}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_MEMBER_SCHOOL">
                                    สถานที่สำเร็จการศึกษา <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="LEVEL_MEMBER_SCHOOL"
                                    name="LEVEL_MEMBER_SCHOOL"
                                    onChange={this.handleSchoolChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุสถานที่สำเร็จการศึกษา
                                    </option>
                                    {this.state.array_school.map((data) => {
                                      return data.name_school === this.state.LEVEL_MEMBER_SCHOOL ? (
                                        <>
                                          <option value={data.name_school} selected>
                                            {data.name_school} : {data.name_schooleng}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.name_school}>
                                            {" "}
                                            {data.name_school} : {data.name_schooleng}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_EDU_ID">
                                    วุฒิการศึกษาที่สำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="LEVEL_EDU_ID"
                                    name="LEVEL_EDU_ID"
                                    onChange={this.handlelevelChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                    </option>
                                    {this.state.array_level.map((data) => {
                                      return data.LEVEL_EDU_ID === this.state.LEVEL_EDU_ID ? (
                                        <>
                                          <option value={data.LEVEL_EDU_ID} selected>
                                            {data.LEVEL_EDU_NAME}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.LEVEL_EDU_ID}>
                                            {data.LEVEL_EDU_NAME}
                                          </option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="PLAN_NAME">
                                    แผนการเรียน / สาขาวิชา / วิชาเอก{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="PLAN_NAME"
                                    name="PLAN_NAME"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุแผนการเรียน / สาขาวิชา / วิชาเอก
                                    </option>
                                    {this.state.array_plan.map((data) => {
                                      return data.PLAN_NAME === this.state.PLAN_NAME ? (
                                        <>
                                          <option value={data.PLAN_NAME} selected>
                                            {data.PLAN_NAME}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.PLAN_NAME}>{data.PLAN_NAME}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_MEMBER_VGA">
                                    ผลการเรียนเฉลี่ยตลอดหลักสูตร{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="LEVEL_MEMBER_VGA"
                                    name="LEVEL_MEMBER_VGA"
                                    maxlength="4"
                                    value={this.state.LEVEL_MEMBER_VGA}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_DATE">
                                    วันอนุมัติการสำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <MDBRow>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="ddate"
                                        name="ddate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวัน
                                        </option>
                                        {this.selectday.map((data) => {
                                          return data.value === this.state.ddate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="mdate"
                                        name="mdate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุเดือน
                                        </option>
                                        {this.selectmonth.map((data) => {
                                          return data.value === this.state.mdate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol>
                                      <select
                                        className="form-control"
                                        id="ydate"
                                        name="ydate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุปี
                                        </option>
                                        {this.state.selectyear.map((data) => {
                                          return data.value === this.state.ydate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                  </MDBRow>
                                </div>
                              </MDBCol>
                              {/* <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="LEVEL_MEMBER_YEAR">
                                    ปีการศึกษาที่สำเร็จการศึกษา <span className="text-danger">*</span> 
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="LEVEL_MEMBER_YEAR"
                                    name="LEVEL_MEMBER_YEAR"
                                    value={this.state.LEVEL_MEMBER_YEAR}
                                    onChange={this.handleChange}
                                    required
                                  />
                                  <text style={{fontSize:'12px'}} className="text-danger" >
                                                                     ตัวอย่าง 
วันอนุมัติการสำเร็จการศึกษา 31 มีนาคม 2568  
ปีการศึกษาที่สำเร็จการศึกษา ต้องเป็น 2566
                                  </text>
 
                                </div>
                              </MDBCol> */}
                            </MDBRow>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      {this.state.REGISTER_TYPE_ID === "7" ? (
                        <div className="col-12 mt-3 p-0">
                          <div className="label " style={{ fontWeight: "600" }}>
                            วุฒิการศึกษาระดับปริญญาโท
                          </div>
                          <MDBRow>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  className="form-label"
                                  for="LEVEL_MEMBER_PROVINCYTOR"
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                >
                                  จังหวัดที่ตั้งสถานที่สำเร็จการศึกษา{" "} 
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  id="LEVEL_MEMBER_PROVINCYTOR"
                                  name="LEVEL_MEMBER_PROVINCYTOR"
                                  onChange={this.handleProvinceChangeTor}
                                  required
                                >
                                  <option value="" hidden>
                                    ระบุจังหวัดที่ตั้งสถานที่สำเร็จการศึกษา
                                  </option>
                                  {this.state.array_provinceTor.map((data) => {
                                    return data.PROVINCE_NAME_TH ===
                                      this.state.LEVEL_MEMBER_PROVINCYTOR ? (
                                      <>
                                        <option value={data.PROVINCE_NAME_TH} selected>
                                          {data.PROVINCE_NAME_TH} 
                                        </option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={data.PROVINCE_NAME_TH}>
                                          {data.PROVINCE_NAME_TH}
                                        </option>
                                      </>
                                    );
                                  })}
                                </select>
                              </div>
                            </MDBCol>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="LEVEL_MEMBER_SCHOOL"
                                >
                                  สถานที่สำเร็จการศึกษา <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  id="LEVEL_MEMBER_SCHOOL"
                                  name="LEVEL_MEMBER_SCHOOLTOR"
                                  onChange={this.handleSchoolChangeTor}
                                  required
                                >
                                  <option value="" hidden>
                                    ระบุสถานที่สำเร็จการศึกษา
                                  </option>
                                  {this.state.array_schoolTor.map((data) => {
                                    return data.name_school ===
                                      this.state.LEVEL_MEMBER_SCHOOLTOR ? (
                                      <>
                                        <option value={data.name_school} selected>
                                          {data.name_school} : {data.name_schooleng}
                                        </option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={data.name_school}>
                                          {" "}
                                          {data.name_school} : {data.name_schooleng}
                                        </option>
                                      </>
                                    );
                                  })}
                                </select>
                              </div>
                            </MDBCol>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="LEVEL_EDU_ID"
                                >
                                  วุฒิการศึกษาที่สำเร็จการศึกษา{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  id="LEVEL_EDU_ID"
                                  name="LEVEL_EDU_IDTor"
                                  onChange={this.handlelevelChangeTor}
                                  required
                                >
                                  <option value="" hidden>
                                    ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                  </option>
                                  {this.state.array_level.map((data) => {
                                    return data.LEVEL_EDU_ID === this.state.LEVEL_EDU_IDTor ? (
                                      <>
                                        <option value={data.LEVEL_EDU_ID} selected>
                                          {data.LEVEL_EDU_NAME}
                                        </option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={data.LEVEL_EDU_ID}>
                                          {data.LEVEL_EDU_NAME}
                                        </option>
                                      </>
                                    );
                                  })}
                                </select>
                              </div>
                            </MDBCol>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="PLAN_NAME"
                                >
                                  แผนการเรียน / สาขาวิชา / วิชาเอก{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  id="PLAN_NAME"
                                  name="PLAN_NAMETor"
                                  onChange={this.handleChange}
                                  required
                                >
                                  <option value="" hidden>
                                    ระบุแผนการเรียน / สาขาวิชา / วิชาเอก
                                  </option>
                                  {this.state.array_planTor.map((data) => {
                                    return data.PLAN_NAME === this.state.PLAN_NAMETor ? (
                                      <>
                                        <option value={data.PLAN_NAME} selected>
                                          {data.PLAN_NAME}
                                        </option>
                                      </>
                                    ) : (
                                      <>
                                        <option value={data.PLAN_NAME}>{data.PLAN_NAME}</option>
                                      </>
                                    );
                                  })}
                                </select>
                              </div>
                            </MDBCol>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="LEVEL_MEMBER_VGATOR"
                                >
                                  ผลการเรียนเฉลี่ยตลอดหลักสูตร{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="LEVEL_MEMBER_VGA"
                                  name="LEVEL_MEMBER_VGATOR"
                                  maxlength="4"
                                  value={this.state.LEVEL_MEMBER_VGATOR}
                                  onChange={this.handleChange}
                                  required
                                />
                              </div>
                            </MDBCol>
                            <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="LEVEL_DATE"
                                >
                                  วันอนุมัติการสำเร็จการศึกษา <span className="text-danger">*</span>
                                </label>
                                <MDBRow>
                                  <MDBCol>
                                    <select
                                      className="form-control"
                                      id="ddate"
                                      name="ddateTor"
                                      onChange={this.handleChange}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุวัน
                                      </option>
                                      {this.selectday.map((data) => {
                                        return data.value === this.state.ddateTor ? (
                                          <>
                                            <option value={data.value} selected>
                                              {data.label}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.value}>{data.label}</option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </MDBCol>
                                  <MDBCol>
                                    <select
                                      className="form-control"
                                      id="mdate"
                                      name="mdateTor"
                                      onChange={this.handleChange}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุเดือน
                                      </option>
                                      {this.selectmonth.map((data) => {
                                        return data.value === this.state.mdateTor ? (
                                          <>
                                            <option value={data.value} selected>
                                              {data.label}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.value}>{data.label}</option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </MDBCol>
                                  <MDBCol>
                                    <select
                                      className="form-control"
                                      id="ydate"
                                      name="ydateTor"
                                      onChange={this.handleChange}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุปี
                                      </option>
                                      {this.state.selectyear.map((data) => {
                                        return data.value === this.state.ydateTor ? (
                                          <>
                                            <option value={data.value} selected>
                                              {data.label}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.value}>{data.label}</option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </MDBCol>
                                </MDBRow>
                              </div>
                            </MDBCol>
                            {/* <MDBCol lg="4" md="6" sm="12">
                              <div className="form-outline mt-2">
                                <label
                                  style={{
                                    fontSize: "14px",
                                    color: "#00000090",
                                    fontWeight: "500",
                                  }}
                                  className="form-label"
                                  for="LEVEL_MEMBER_YEARTor"
                                >
                                  ปีการศึกษาที่สำเร็จการศึกษา <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="LEVEL_MEMBER_YEAR"
                                  name="LEVEL_MEMBER_YEARTor"
                                  value={this.state.LEVEL_MEMBER_YEARTor}
                                  onChange={this.handleChange}
                                  required
                                />
                                <text style={{fontSize:'12px'}} className="text-danger" >
                                                                     ตัวอย่าง 
วันอนุมัติการสำเร็จการศึกษา 31 มีนาคม 2568  
ปีการศึกษาที่สำเร็จการศึกษา ต้องเป็น 2566
                                  </text>
                              </div>
                            </MDBCol> */}
                          </MDBRow>
                        </div>
                      ) : (
                        <></>
                      )}
                      {this.state.REGISTER_TYPE_ID === "4" ||
                      this.state.REGISTER_TYPE_ID === "7" ? (
                        <>
                          <label className="mt-1" htmlFor="asd">
                            {this.state.REGISTER_TYPE_ID === "4"
                              ? "มีวุฒิ ป.วิชาชีพครูหรือไม"
                              : "มีวุฒิ ทางการบริการการศึกษา หรือไม่ ?"}{" "}
                            ่
                          </label>
                          <Radio.Group
                            id="asd"
                            value={this.state.ask}
                            onChange={this.Vut}
                            className="d-flex"
                            style={{ gap: "10px" }}
                          >
                            <Radio value={1}>มี</Radio>
                            <Radio value={2}>ไม่มี</Radio>
                          </Radio.Group>
                          <br />
                          {this.state.ask === 1 ? (
                            <>
                              <MDBRow>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_MEMBER_PROVINCY2">
                                      จังหวัดที่ตั้งสถานที่สำเร็จการศึกษา{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="LEVEL_MEMBER_PROVINCY2"
                                      name="LEVEL_MEMBER_PROVINCY2"
                                      onChange={this.handleProvinceChange2}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุจังหวัดที่ตั้งสถานที่สำเร็จการศึกษา
                                      </option>
                                      {this.state.array_province2.map((data) => {
                                        return data.PROVINCE_NAME_TH ===
                                          this.state.LEVEL_MEMBER_PROVINCY2 ? (
                                          <>
                                            <option value={data.PROVINCE_NAME_TH} selected>
                                              {data.PROVINCE_NAME_TH}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.PROVINCE_NAME_TH}>
                                              {data.PROVINCE_NAME_TH}
                                            </option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </MDBCol>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_MEMBER_SCHOOL2">
                                      สถานที่สำเร็จการศึกษา <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="LEVEL_MEMBER_SCHOOL2"
                                      name="LEVEL_MEMBER_SCHOOL2"
                                      onChange={this.handleSchoolChange2}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุสถานที่สำเร็จการศึกษา
                                      </option>
                                      {this.state.array_school2.map((data) => {
                                        return data.name_school ===
                                          this.state.LEVEL_MEMBER_SCHOOL2 ? (
                                          <>
                                            <option value={data.name_school} selected>
                                              {data.name_school} : {data.name_schooleng}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.name_school}>
                                              {data.name_school} : {data.name_schooleng}
                                            </option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </MDBCol>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_EDU_ID2">
                                      วุฒิการศึกษาที่สำเร็จการศึกษา{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="LEVEL_EDU_ID2"
                                      name="LEVEL_EDU_ID2"
                                      onChange={this.handlelevelChange2}
                                      value={this.state.LEVEL_EDU_ID2}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                      </option>
                                      {this.state.array_level.map((data) => {
                                        return data.LEVEL_EDU_ID === "13" ? (
                                          data.LEVEL_EDU_ID === this.state.LEVEL_EDU_ID2 ? (
                                            <>
                                              <option value={data.LEVEL_EDU_ID} selected>
                                                {data.LEVEL_EDU_NAME}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.LEVEL_EDU_ID}>
                                                {data.LEVEL_EDU_NAME}
                                              </option>
                                            </>
                                          )
                                        ) : (
                                          <></>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </MDBCol>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="PLAN_NAME2">
                                      แผนการเรียน
                                      <span className="text-danger">*</span>
                                    </label>
                                    <select
                                      className="form-control"
                                      id="PLAN_NAME2"
                                      name="PLAN_NAME2"
                                      onChange={this.handleChange}
                                      required
                                    >
                                      <option value="" hidden>
                                        ระบุแผนการเรียน
                                      </option>
                                      {this.state.array_plan2.map((data) => {
                                        return data.PLAN_NAME === this.state.PLAN_NAME2 ? (
                                          <>
                                            <option value={data.PLAN_NAME} selected>
                                              {data.PLAN_NAME}
                                            </option>
                                          </>
                                        ) : (
                                          <>
                                            <option value={data.PLAN_NAME}>{data.PLAN_NAME}</option>
                                          </>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </MDBCol>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_MEMBER_VGA2">
                                      ผลการเรียนเฉลี่ยตลอดหลักสูตร
                                      <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="LEVEL_MEMBER_VGA"
                                      name="LEVEL_MEMBER_VGA2"
                                      maxlength="4"
                                      value={this.state.LEVEL_MEMBER_VGA2}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </MDBCol>
                                <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_DATE2">
                                      วันอนุมัติการสำเร็จการศึกษา{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <MDBRow>
                                      <MDBCol>
                                        <select
                                          className="form-control"
                                          id="ddate2"
                                          name="ddate2"
                                          onChange={this.handleChange}
                                          required
                                        >
                                          <option value="" hidden>
                                            ระบุวัน
                                          </option>
                                          {this.selectday.map((data) => {
                                            return data.value === this.state.ddate2 ? (
                                              <>
                                                <option value={data.value} selected>
                                                  {data.label}
                                                </option>
                                              </>
                                            ) : (
                                              <>
                                                <option value={data.value}>{data.label}</option>
                                              </>
                                            );
                                          })}
                                        </select>
                                      </MDBCol>
                                      <MDBCol>
                                        <select
                                          className="form-control"
                                          id="mdate"
                                          name="mdate2"
                                          onChange={this.handleChange}
                                          required
                                        >
                                          <option value="" hidden>
                                            ระบุเดือน
                                          </option>
                                          {this.selectmonth.map((data) => {
                                            return data.value === this.state.mdate2 ? (
                                              <>
                                                <option value={data.value} selected>
                                                  {data.label}
                                                </option>
                                              </>
                                            ) : (
                                              <>
                                                <option value={data.value}>{data.label}</option>
                                              </>
                                            );
                                          })}
                                        </select>
                                      </MDBCol>
                                      <MDBCol>
                                        <select
                                          className="form-control"
                                          id="ydate"
                                          name="ydate2"
                                          onChange={this.handleChange}
                                          required
                                        >
                                          <option value="" hidden>
                                            ระบุปี
                                          </option>
                                          {this.state.selectyear.map((data) => {
                                            return data.value === this.state.ydate2 ? (
                                              <>
                                                <option value={data.value} selected>
                                                  {data.label}
                                                </option>
                                              </>
                                            ) : (
                                              <>
                                                <option value={data.value}>{data.label}</option>
                                              </>
                                            );
                                          })}
                                        </select>
                                      </MDBCol>
                                    </MDBRow>
                                  </div>
                                </MDBCol>
                                {/* <MDBCol lg="4" md="6" sm="12">
                                  <div className="form-outline mt-2">
                                    <label className="form-label" for="LEVEL_MEMBER_YEAR2">
                                      ปีการศึกษาที่สำเร็จการศึกษา <span className="text-danger">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="LEVEL_MEMBER_YEAR2"
                                      name="LEVEL_MEMBER_YEAR2"
                                      value={this.state.LEVEL_MEMBER_YEAR2}
                                      onChange={this.handleChange}
                                      required
                                    />
                                    <text style={{fontSize:'12px'}} className="text-danger" >
                                                                     ตัวอย่าง 
วันอนุมัติการสำเร็จการศึกษา 31 มีนาคม 2568  
ปีการศึกษาที่สำเร็จการศึกษา ต้องเป็น 2566
                                  </text>
                                  </div>
                                </MDBCol> */}
                              </MDBRow>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <></>
                      )}

                      <br />
                      {this.state.LEVEL_MEMBER_PROVINCY &&
                      this.state.LEVEL_MEMBER_SCHOOL &&
                      this.state.LEVEL_EDU_ID &&
                      this.state.PLAN_NAME &&
                      this.state.LEVEL_MEMBER_VGA &&
                      this.state.ddate &&
                      this.state.mdate &&
                      this.state.ydate ? (
                        // &&
                        // this.state.LEVEL_MEMBER_YEAR
                        <>
                          <button
                            type="submit"
                            className="btn btn-primary btn-rounded btn-md mt-2"
                            disabled={
                              this.state.ask === 1
                                ? this.state.LEVEL_MEMBER_PROVINCY2 &&
                                  this.state.LEVEL_MEMBER_SCHOOL2 &&
                                  this.state.LEVEL_EDU_ID2 &&
                                  this.state.PLAN_NAME2 &&
                                  this.state.LEVEL_MEMBER_VGA2 &&
                                  this.state.ddate2 &&
                                  this.state.mdate2 &&
                                  this.state.ydate2
                                  ? // &&
                                    // this.state.LEVEL_MEMBER_YEAR2
                                    false
                                  : true
                                : false
                            }
                          >
                            บันทึกข้อมูล
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="submit"
                            className="btn btn-primary btn-rounded btn-md mt-2"
                            disabled
                          >
                            บันทึกข้อมูล
                          </button>
                        </>
                      )}
                      <a
                        className="btn btn-rounded btn-md mt-2 float-right black-text"
                        href="Insertpresent3"
                        style={{ backgroundColor: "#CBCBCB" }}
                      >
                        ข้าม
                      </a>
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}
